var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-two-columns-center"},[_c('div',[_vm._t("col-1")],2),_c('div',[_vm._t("col-2")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }